import React, { useState } from "react";
import Lca from "./Immigration/Lca";
import H1B from "./Immigration/H1B";
import Visa from "./Immigration/Visa";
import GreenCard from "./Immigration/GreenCard";
import AddH1B from "./Immigration/H1B/AddH1B";
import { NewTab, PageHeader, PageTab, PageTitle } from "../../../components";
import AddLca from "./Immigration/Lca/AddLca";
import JobsandAdvertisements from "./Immigration/JobsandAdvertisements";
import AddAdwartisements from "./Immigration/JobsandAdvertisements/AddAdwartisements";
import AddGreencard from "./Immigration/GreenCard/AddGreencard";
import { addCurrentImmigrations } from "../../../redux/slices/immigration/immigrationSlice";
import { useDispatch } from "react-redux";

const Immigration = () => {
  const dispatch = useDispatch();
  const [activeSubTab, setActiveSubTab] = useState(null);
  const [activeMainTabIndex, setActiveMainTabIndex] = useState(0);
  const [editData, setEditData] = useState(null);
  const [activeModal, setActiveModal] = useState(false);
  const [createManuval, setCreateManuval] = useState(false);
  const handleBack = () => {
    setActiveSubTab(null);
    setEditData(null);
  };
  const handleEdit = (data) => {
    setEditData(data);
    setActiveSubTab("H1BAdd");
  };
  const handleRemove = () => {
    dispatch(addCurrentImmigrations({}));
  };
  const handleEditLca = (row) => {
    handleRemove();
    setActiveSubTab("addLCA");
    setEditData(row);
    setCreateManuval(true);
  };
  const ImmigrationMenus = [
    {
      title: "LCA",
      page:
        activeSubTab === "addLCA" ? (
          <AddLca
            handleBack={handleBack}
            setCreateManuval={setCreateManuval}
            createManuval={createManuval}
            editData={editData}
          />
        ) : (
          <Lca handleEdit={handleEditLca} />
        ),
      type: "main",
      subTabs:
        activeSubTab === "addLCA"
          ? []
          : [
              {
                title: "Add LCA",
                icon: "add",
                action: () => {
                  setEditData(null);
                  setActiveSubTab("addLCA");
                  handleRemove();
                },
              },
            ],
    },
    {
      title: "H-1B",
      page:
        activeSubTab === "addH1B" || activeSubTab === "editH1B" ? (
          <AddH1B
            handleBack={handleBack}
            editData={activeSubTab === "editH1B" ? editData : null}
            isEditMode={activeSubTab === "editH1B" ? true : false}
          />
        ) : (
          <H1B
            onEdit={(row) => {
              setEditData(row);
              setActiveSubTab("editH1B");
            }}
          />
        ),
      type: "main",
      subTabs:
        activeSubTab === "addH1B" || activeSubTab === "editH1B"
          ? []
          : [
              {
                title: "Add H-1B",
                icon: "add",
                action: () => {
                  setActiveSubTab("addH1B");
                  setEditData(null);
                },
              },
            ],
    },
    {
      title: "Visa",
      page: <Visa activeModal={activeModal} setActiveModal={setActiveModal} />,
      type: "main",
      subTabs: [
        {
          title: "Add Visa",
          icon: "add",
          action: () => {
            setEditData(null);
            setActiveModal(true);
            handleRemove();
            // implement modal or other logic
          },
        },
      ],
    },
    // {
    //   title: "Green Card",
    //   page:
    //     activeSubTab === "addGreencard" || activeSubTab === "editGreencard" ? (
    //       <AddGreencard
    //         handleBack={handleBack}
    //         editData={activeSubTab === "editGreencard" ? editData : null}
    //         isEditMode={activeSubTab === "editGreencard"? true : false}
    //       />
    //     ) : (
    //       <GreenCard
    //         onEdit={(row) => {
    //           setEditData(row);
    //           setActiveSubTab("editGreencard");
    //         }}
    //       />
    //     ),
    //   type: "main",
    //   subTabs:
    //     activeSubTab === "addGreencard" || activeSubTab === "editGreencard"
    //       ? []
    //       : [
    //           {
    //             title: "Add Green Card",
    //             icon: "add",
    //             action: () => setActiveSubTab("addGreencard"),
    //           },
    //         ],
    // },
    //    {
    //   title: "Jobs & Advertisements",
    //   page:
    //     activeSubTab === "addAdvertisement" ? (
    //       <AddAdwartisements handleBack={handleBack} />
    //     ) : (
    //       <JobsandAdvertisements
    //         onAdd={() => setActiveSubTab("addAdvertisement")}
    //       />
    //     ),
    //   type: "main",
    //   subTabs:
    //     activeSubTab === "addAdvertisement"
    //       ? []
    //       : [
    //           {
    //             title: "Add Advertisement",
    //             icon: "add",
    //             action: () => setActiveSubTab("addAdvertisement"),
    //           },
    //         ],
    // }
  ];

  const handleTabChange = (index) => {
    setActiveMainTabIndex(index);
    setActiveSubTab(null);
    setEditData(null);
  };

  return (
    <>
      <PageHeader
        Section={
          <div className="flex my-3">
            <PageTitle title={"Immigration"} tag="h5" />
          </div>
        }
      />
      <NewTab
        tabs={ImmigrationMenus}
        color="black"
        variant="outlined"
        onTabChange={handleTabChange}
        mode="url"
        tabId="immigration"
      />
      {/* <Mod */}
    </>
  );
};

export default Immigration;
